<template>
  <section>
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap justify-center text-center mb-24">
        <div class="w-full lg:w-8/12 px-4">
          <h2 class="text-4xl font-semibold">Jobs</h2>
          <p
            class="text-lg leading-relaxed m-4 text-gray-600"
          >Derzeit sind alle Stellen besetzt, wir freuen uns aber auf Ihre <a href="#contactForm" v-smooth-scroll>Initiativbewerbung</a>.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {
  }
};
</script>

<style>
</style>